import { Node, Schema } from 'prosemirror-model'
import { markdownParser } from 'prose-core'

export const parseRevisionContent = (schema: Schema, markdown: string) => {
  let content = (markdownParser.parse(markdown)?.content.toJSON() as any[]) || []

  if (content.length > 1 && !content[content.length - 1].content) {
    // trim trailing empty content
    content = content.slice(0, -1)
  }

  return Node.fromJSON(schema, { type: 'doc', content })
}
